import { useMutation } from "@tanstack/react-query";
import { getUsersWithLiveTrainingInfo } from "api/services/lesson-service";
import { useAuthContext } from "hooks/useAuthContext";
import { LiveTrainingData } from "models/LiveTrainingData";

interface CheckUsersLiveTrainingProgressesParams {
    userIds: string[];
    lessonId: string;
}

export const useCheckUsersLiveTrainingProgresses = () => {
    const { userState } = useAuthContext();

    const mutation = useMutation({
        mutationFn: async ({ userIds, lessonId }: CheckUsersLiveTrainingProgressesParams): Promise<LiveTrainingData[]> => {
            const workspaceId = userState.user.selectedWorkspace.workspaceId;

            if (!workspaceId) {
                return [];
            }

            const response = await getUsersWithLiveTrainingInfo({
                userIds,
                lessonIds: [lessonId],
                workspaceId,
            });

            if (!response?.success || !response.data) {
                return [];
            }

            return response.data;
        }
    });

    return {
        checkUsersLiveTrainingProgresses: mutation.mutateAsync,
        checkingUsersLiveTrainingProgresses: mutation.isPending,
    };
}